import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render financial projections section for FAQ Page
 */
const FinancialProjectionsSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="financial-projections-section-component"
    >
      <AccordionV2
        testId="financial-projections"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="3. Are financial projections taken into account when shortlisting the entities?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 pb-2 pt-6">
          <p>
            Financial projections will be taken into consideration. Shortlisting
            will also be based on the business owner’s or management team’s
            justification on how he/she/they is/are going to achieve the plans
            and if the projections are achievable.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default FinancialProjectionsSection;
